export const ActiveItemStatus = {
  REQUEST: 'ACTIVE_ITEM_REQUEST',
  SUCCESS: 'ACTIVE_ITEM_SUCCESS',
  ERROR: 'ACTIVE_ITEM_ERROR',
  RESET: 'ACTIVE_ITEM_RESET',
  REQUEST_UNIT: 'ACTIVE_UNIT_ITEM_REQUEST',
  SUCCESS_UNIT: 'ACTIVE_UNIT_ITEM_SUCCESS',
  ERROR_UNIT: 'ACTIVE_UNIT_ITEM_ERROR',
};
